import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  WfMdActionTypeService,
  WfMdActionTypeContainerModel
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../visa';

@Component({
  selector: 'app-workflow-action-type',
  templateUrl: './workflow-action-type.component.html',
  styleUrls: ['./workflow-action-type.component.css']
})
export class WorkflowActionTypeComponent implements OnInit, OnDestroy {

  @Input() actionType: FormControl;
  @Output() actionTypeChange = new EventEmitter<FormControl>();

  private subs = new SubSink();

  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<WfMdActionTypeContainerModel[]> = new ReplaySubject<WfMdActionTypeContainerModel[]>(1);
  actionTypeList: WfMdActionTypeContainerModel[];

  constructor( private actionTypeService: WfMdActionTypeService ) {}

  ngOnInit() {
    this.subs.sink = this.actionTypeService.get(this.apiVisa).subscribe(
      {next: resolve => {
        this.actionTypeList = resolve.data;
        this.filteredOptions$.next(this.actionTypeList);
      }});
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterApplet(resolve)});
  }

  filterApplet(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.actionTypeList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.actionTypeList.filter(c => c.bl_wf_md_action_type.name.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
